<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1> Transaction History</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active"> Transaction History</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'EWTrxHistoryList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID </strong> {{ value.id }}</li>
                  <li><strong>Sender </strong> {{ !_.isEmpty(value.sender_user) ? value.sender_user.name : 'NA' }}</li>
                  <li><strong>Receiver </strong> {{ !_.isEmpty(value.receiver_user) ? value.receiver_user.name : 'NA' }}
                  </li>
                  <li><strong>Owner </strong> {{ !_.isEmpty(value.owner_user) ? value.owner_user.name : 'NA' }}</li>
                  <li><strong>Activity Type </strong>
                    {{ !_.isEmpty(value.trx_activity_type) ? value.trx_activity_type.activity_type : 'NA' }}
                  </li>
                  <li><strong>Type </strong> {{
                      !_.isEmpty(value.trx_type) ? value.trx_type.charAt(0).toUpperCase() + value.trx_type.slice(1) : "NA"
                    }}
                  </li>
                  <li><strong>Amount </strong>
                    {{ !_.isEmpty(value.trx_amount) ? parseFloat(value.trx_amount).toFixed(2) : "" }}
                  </li>

                  <li><strong>Is Charge </strong>
                    {{
                      !_.isEmpty(value.is_charge) ? value.is_charge.charAt(0).toUpperCase() + value.is_charge.slice(1) : 'no'
                      }}
                  </li>

                  <li><strong>Note </strong> {{ !_.isEmpty(value.trx_note) ? value.trx_note : "" }}</li>
                  <li><strong>Balance </strong>
                    {{
                      !_.isEmpty(value.balance) ? parseFloat(value.balance).toFixed(2) : 0
                      }}
                  </li>

                  <li><strong>UUID </strong> {{ !_.isEmpty(value.trx_uuid) ? value.trx_uuid : "NA" }}</li>
                  <li><strong>Reference </strong> {{ !_.isEmpty(value.trx_reference) ? value.trx_reference : "NA" }}</li>

                  <li><strong>Status </strong> {{ !_.isEmpty(value.trx_status) ? value.trx_status : 0 }}</li>
                  <li><strong>Created Time </strong> {{ customFormatter(value.created_at, 'lll') }}</li>
                  <li><strong>Updated Time </strong> {{ customFormatter(value.updated_at, 'lll') }}</li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from '@/services/api'
import axios from 'axios'
import {Notification} from 'element-ui'
import moment from "moment";

const fileDownload = require("js-file-download")


export default {
  name: 'EWTrxHistoryShow',
  metaInfo: {
    title: ' Trx History | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    customFormatter(date, format = 'MMM Do YY, h:mm:ss a') {
      return moment(date).format(format);
    },
    async initialize() {
      this.is_loading = true
      this.params = this.$route.params


      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      });

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios.get(this.API_ASSET_UPLOAD_URL + url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({title: 'Download Failed', message: 'Failed to download', type: 'error'})
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = '/ew_trx_histories/' + id;
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            console.error('error ' + error)
            reject(error)
          })
          .finally(() => {
          });
      })
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
